import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { OperatorSession } from '@kontor/shared';
import { api, ApiError } from '../api';

/** Aufruf der Betreiber-API unter /operator. Die Anmeldung läuft über ein eigenes Cookie, das mit der Anmeldung der Mandanten nichts zu tun hat. */
export const operatorApi = <T>(method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE', path: string, body?: unknown) => api<T>(method, `/operator${path}`, body);

/** Die Sitzung des Betreibers. null, wenn niemand angemeldet ist. */
export function useOperator() {
  const client = useQueryClient();
  const query = useQuery({
    queryKey: ['operator-session'],
    queryFn: async () => {
      try {
        return (await operatorApi<{ data: OperatorSession }>('GET', '/auth/me')).data;
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    retry: false,
    staleTime: 60_000,
  });
  const logout = useMutation({
    mutationFn: () => operatorApi('POST', '/auth/logout'),
    onSettled: () => {
      // Alle Daten der Betreiber verwerfen, die Sitzungsabfrage bleibt bestehen
      client.removeQueries({ predicate: (q) => q.queryKey[0] !== 'operator-session' && String(q.queryKey[0]).startsWith('operator') });
      client.setQueryData(['operator-session'], null);
    },
  });
  return { session: query.data ?? null, loading: query.isLoading, error: query.error, logout: () => logout.mutateAsync() };
}
